module.exports = __webpack_public_path__ + "static/img/system-img-left.5a1131f1.png";